import { StyleSheet } from "@react-pdf/renderer";
const Services = () => {
    const styles = StyleSheet.create({
        page: {
            flexDirection: "row",
            backgroundColor: "#61dafb",
        },
        nobullets: {
            listStyleType: "none",
        }
    });
    return (
        <div style={styles.page}>
            <div>
                <p>
                    Internet Software Works (ISW) is a software development consultancy
                    specializing in custom full stack development. ISW can take your vision
                    and make it a reality using the latest technology and development processes.
                    ISW can also provide consulting on hosting options to reduce costs
                    and increase performance. ISW provides development services for mobile and multi language web based applications. ISW is a full stack development shop, send us your idea and we can make it a reality!
                </p>
            </div>
            <div>
                <ul style={styles.nobullets}>
                    <li>Full-stack application development</li>
                    <li>Non-Emergency Medical Transport (NEMT) consulting</li>
                    <li>Product design, including epics and user stories</li>
                    <li>Mobile Application development</li>
                    <li>Hosting and cloud infrastructure consulting</li>
                    <li>Database design, optimization, and performance tuning</li>
                    <li>API development and integration</li>
                    <li>Cloud architecture and deployment</li>
                    <li>Ongoing maintenance and support</li>
                </ul>
            </div>
            <div>
                <table><tbody><tr>
                    <td align="left">
                        <h3>Technology Stack</h3>
                        <br />
                        <ul>
                            <li>Frontend: React, HTML, JavaScript</li>
                            <li>Backend: Java, Spring Boot, Node.js, TypeScript</li>
                        </ul>
                    </td><td align="right">

                    </td>
                </tr></tbody></table>
            </div>
        </div>
    );
};
export default Services;
